import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { useClients } from './hooks/useClients';
import Paths from './models/enums/paths';
import { AppContext } from './shared/app-context';

/**
 * Wrapper around fan segmentation routes to prevent users without access from navigating to segmentation pages directly
 */
const SegmentsRoutesWrapper = ({ children }: { children: React.ReactNode }) => {
  const { state } = React.useContext(AppContext);
  const clientsQuery = useClients();

  const currentClient = React.useMemo(() => {
    if (clientsQuery.data && state.clientId) {
      return clientsQuery.data.results.find(client => client.clientId === state.clientId);
    }
  }, [state, clientsQuery.data]);

  if (!currentClient) {
    return null;
  }

  if (currentClient && !currentClient.enableSegmentation) {
    return <Redirect to={Paths.Reports} />;
  }

  return <React.Fragment>{children}</React.Fragment>;
};

export default SegmentsRoutesWrapper;
